import api from './api';

// Puantaj Plan 3, Task 4 — Vardiya Dışı Onayları sayfası. Backend sözleşmeleri Plan 2'den
// (değişmez): bkz. Dtos/OvertimeApproval/OvertimeApprovalDtos.cs.
export const getPendingOvertimeApprovals = (params) => api.get('/v1/ta/overtime-approvals/pending', { params });
export const getOvertimeApprovals = (params) => api.get('/v1/ta/overtime-approvals', { params });
export const decideOvertimeApproval = (data) => api.post('/v1/ta/overtime-approvals/decide', data);
// ≤200 öğe (backend clamp) — kısmi başarı SESSİZ DEĞİL: { succeeded, failed: [{userId,date,error}] }.
export const decideOvertimeApprovalsBulk = (data) => api.post('/v1/ta/overtime-approvals/decide-bulk', data);
